export function lenisScroll() {
  if (!window.lenis && typeof Lenis !== "undefined") {
    window.lenis = new Lenis({
      smooth: true,
      smoothTouch: true,
      touchMultiplier: 1.5,
      lerp: 0.08,
      prevent: (node) => node.closest('.nav-dropdown')
    });
    

    // GSAP sync = ultra smooth
    gsap.ticker.add((time) => {
      window.lenis.raf(time * 1500);
    });
    gsap.ticker.lagSmoothing(0);
  }
}
